// extracted by mini-css-extract-plugin
export default {"form":"DeleteProfileForm_form__RoD5w","enterPassword":"DeleteProfileForm_enterPassword__RxsLx","errorMessage":"DeleteProfileForm_errorMessage__j9WS7"};